import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconService {

  private readonly SVG_ICONS: Icon[] = [
    { filename: '123' },
    { filename: 'account_box' },
    { filename: 'account_tree' },
    { filename: 'active_circle' },
    { filename: 'add_box' },
    { filename: 'add_camera' },
    { filename: 'addchart' },
    { filename: 'add_circle_fill' },
    { filename: 'add_circle_outline' },
    { filename: 'add_or_edit' },
    { filename: 'add_text_icon' },
    { filename: 'ads' },
    { filename: 'ads_select_option' },
    { filename: 'apps' },
    { filename: 'arrow_downward' },
    { filename: 'arrow_upward' },
    { filename: 'assignments' },
    { filename: 'autopause' },
    { filename: 'autoplay' },
    { filename: 'autorenew' },
    { filename: 'bolt' },
    { filename: 'bus' },
    { filename: 'bus_stop_data_report' },
    { filename: 'bus_stop_off' },
    { filename: 'bus_stop_on' },
    { filename: 'bus_stop_report' },
    { filename: 'diagnostic-reports' },
    { filename: 'calendar' },
    { filename: 'calendar_month' },
    { filename: 'calendar_view_month' },
    { filename: 'camera' },
    { filename: 'cancel' },
    { filename: 'chart_on_documents' },
    { filename: 'chevron_backward' },
    { filename: 'chevron_forward' },
    { filename: 'chevron_right' },
    { filename: 'clear_all' },
    { filename: 'clients' },
    { filename: 'close' },
    { filename: 'close-popup' },
    { filename: 'column-layout' },
    { filename: 'confirm-message' },
    { filename: 'container' },
    { filename: 'container_with_background' },
    { filename: 'content_copy' },
    { filename: 'cross' },
    { filename: 'datasync' },
    { filename: 'date_range' },
    { filename: 'delete' },
    { filename: 'delete_1' },
    { filename: 'depot' },
    { filename: 'device_location' },
    { filename: 'devices' },
    { filename: 'devices-status-history' },
    { filename: 'diagnostics' },
    { filename: 'distance_report' },
    { filename: 'dock_to_bottom' },
    { filename: 'dock_to_bottom_fill' },
    { filename: 'done' },
    { filename: 'done_circle' },
    { filename: 'double_arrow_left' },
    { filename: 'download_zipped_report' },
    { filename: 'drag_indicator' },
    { filename: 'ds_devices' },
    { filename: 'duration_edit' },
    { filename: 'eclipse' },
    { filename: 'edit' },
    { filename: 'edit_1' },
    { filename: 'mi/edit_location_alt', name: 'edit_location_alt' },
    { filename: 'mi/edit_location_alt_fill', name: 'edit_location_alt_fill' },
    { filename: 'enter' },
    { filename: 'error_circle' },
    { filename: 'error-logs-report' },
    { filename: 'event' },
    { filename: 'event_list' },
    { filename: 'event_list_fill' },
    { filename: 'exit' },
    { filename: 'exit_to_app' },
    { filename: 'expand_less' },
    { filename: 'expand_more' },
    { filename: 'fiber_manual_record' },
    { filename: 'file_image' },
    { filename: 'file_import' },
    { filename: 'files' },
    { filename: 'file_video' },
    { filename: 'filter_alt' },
    { filename: 'filter_alt_fill' },
    { filename: 'filter_alt_off' },
    { filename: 'filter_list' },
    { filename: 'filter_list_off' },
    { filename: 'fit_page_width' },
    { filename: 'fit_screen' },
    { filename: 'mi/format_color_reset', name: 'format_color_reset' },
    { filename: 'fullscreen' },
    { filename: 'fullscreen_exit' },
    { filename: 'fleet_assignments_edit' },
    { filename: 'fleet_assignments_preview' },
    { filename: 'fleetmanagement' },
    { filename: 'fleet_registry' },
    { filename: 'fleet_registry_manuals' },
    { filename: 'fleet_vehicles_edit' },
    { filename: 'fleet_vehicles_preview' },
    { filename: 'function' },
    { filename: 'fuel' },
    { filename: 'functions' },
    { filename: 'gesture' },
    { filename: 'gps_fixed' },
    { filename: 'gps_off' },
    { filename: 'gps_phantom_icon_off' },
    { filename: 'gps_phantom_icon_on' },
    { filename: 'grid_3x3' },
    { filename: 'grid_3x3_off' },
    { filename: 'grid_view' },
    { filename: 'group' },
    { filename: 'help' },
    { filename: 'highlight_off' },
    { filename: 'history' },
    { filename: 'home' },
    { filename: 'home_reports' },
    { filename: 'icon_arrow_left' },
    { filename: 'icon_arrow_right' },
    { filename: 'icon_bus_edit' },
    { filename: 'icon_draw_polygon' },
    { filename: 'icon_points_with_line' },
    { filename: 'icon_points_without_line' },
    { filename: 'icon_square' },
    { filename: 'icon_table_edit' },
    { filename: 'icon_window_split_vert' },
    { filename: 'info' },
    { filename: 'info-message' },
    { filename: 'invalid_image' },
    { filename: 'ionic_bus' },
    { filename: 'join' },
    { filename: 'join_fill' },
    { filename: 'join_left' },
    { filename: 'join_right' },
    { filename: 'mi/keep', name: 'keep' },
    { filename: 'mi/keep_off', name: 'keep_off' },
    { filename: 'key_on_documents' },
    { filename: 'language' },
    { filename: 'line_priorities' },
    { filename: 'live_play' },
    { filename: 'location_on' },
    { filename: 'lock' },
    { filename: 'locked' },
    { filename: 'lock_open_right' },
    { filename: 'loupe_on_documents' },
    { filename: 'mail_fill' },
    { filename: 'management' },
    { filename: 'management', name: 'ads_management' },
    { filename: 'map' },
    { filename: 'map_location' },
    { filename: 'material_refresh' },
    { filename: 'measuring-tape-icon' },
    { filename: 'messages' },
    { filename: 'mini-red-error' },
    { filename: 'more_vert' },
    { filename: 'move_end' },
    { filename: 'move_start' },
    { filename: 'mute' },
    { filename: 'next' },
    { filename: 'no-internet' },
    { filename: 'notification' },
    { filename: 'notifications' },
    { filename: 'no_view' },
    { filename: 'no-wifi' },
    { filename: 'open_folder' },
    { filename: 'page_info' },
    { filename: 'palette' },
    { filename: 'panic_button_report' },
    { filename: 'pause_circle' },
    { filename: 'person' },
    { filename: 'person_outline' },
    { filename: 'mi/pin_history', name: 'pin_history' },
    { filename: 'play_arrow' },
    { filename: 'play_circle' },
    { filename: 'playlist' },
    { filename: 'playlist_length' },
    { filename: 'popup' },
    { filename: 'popup-off' },
    { filename: 'popup-on' },
    { filename: 'position_history' },
    { filename: 'power_off' },
    { filename: 'preview', name: 'ads_preview' },
    { filename: 'previous' },
    { filename: 'punishment' },
    { filename: 'receipt_long' },
    { filename: 'recommended' },
    { filename: 'recommended2' },
    { filename: 'rect_zone_off' },
    { filename: 'rect_zone_on' },
    { filename: 'redo' },
    { filename: 'red_error' },
    { filename: 'refresh' },
    { filename: 'remedial_steps' },
    { filename: 'remove_circle_outline' },
    { filename: 'replay' },
    { filename: 'reports' },
    { filename: 'report_summary' },
    { filename: 'reset_settings' },
    { filename: 'reset_sort' },
    { filename: 'review' },
    { filename: 'road-schedule' },
    { filename: 'route_stops_off' },
    { filename: 'route_stops_on' },
    { filename: 'row-layout' },
    { filename: 'sakp_departures' },
    { filename: 'sakp_disputes' },
    { filename: 'sakp_reports' },
    { filename: 'sand-clock' },
    { filename: 'save' },
    { filename: 'schedule-icon' },
    { filename: 'screenshot_icon' },
    { filename: 'search' },
    { filename: 'search_300' },
    { filename: 'search_off' },
    { filename: 'segment_time_report' },
    { filename: 'send' },
    { filename: 'mi/sensors', name: 'sensors' },
    { filename: 'mi/sensors_off', name: 'sensors_off' },
    { filename: 'settings' },
    { filename: 'settings_account_box' },
    { filename: 'mi/share_eta', name: 'share_eta' },
    { filename: 'snvr_download' },
    { filename: 'snvr_events' },
    { filename: 'snvr_player' },
    { filename: 'snvr_server' },
    { filename: 'software-update' },
    { filename: 'sort-alt' },
    { filename: 'sort-alt-slash' },
    { filename: 'sound_off' },
    { filename: 'sound_on' },
    { filename: 'stop_circle' },
    { filename: 'stop_circle_1' },
    { filename: 'sync_report' },
    { filename: 'table_edit' },
    { filename: 'table_eye' },
    { filename: 'table_rows' },
    { filename: 'table_view' },
    { filename: 'tasks' },
    { filename: 'temperature-icon' },
    { filename: 'tenancy' },
    { filename: 'timeline' },
    { filename: 'timeline_recordings' },
    { filename: 'to_all' },
    { filename: 'today' },
    { filename: 'tooltip' },
    { filename: 'mi/tooltip_2', name: 'tooltip_2' },
    { filename: 'tooltip_2_fill' },
    { filename: 'tune' },
    { filename: 'tw_messages' },
    { filename: 'undo' },
    { filename: 'undo_1' },
    { filename: 'unfold_less' },
    { filename: 'unfold_more' },
    { filename: 'unmute' },
    { filename: 'unrecognized' },
    { filename: 'upload' },
    { filename: 'user_activity_log' },
    { filename: 'user-logged' },
    { filename: 'user-logged-off' },
    { filename: 'vehicle_devices' },
    { filename: 'vehicles' },
    { filename: 'vehicles_off' },
    { filename: 'vehicles_on' },
    { filename: 'vehicle_statuses' },
    { filename: 'vertical_align_bottom' },
    { filename: 'vertical_align_center' },
    { filename: 'vertical_align_top' },
    { filename: 'view_column' },
    { filename: 'visibility' },
    { filename: 'visibility_off' },
    { filename: 'visibility_outline' },
    { filename: 'voice_chat' },
    { filename: 'volume_off' },
    { filename: 'volume_up' },
    { filename: 'warning' },
    { filename: 'warning_outline' },
    { filename: 'warning-message' },
    { filename: 'wifi' },
    { filename: 'work_fill' },
    { filename: 'mi/wrong_location', name: 'wrong_location' },
    { filename: 'zone_off' },
    { filename: 'zone_on' },
    { filename: 'zoom_in' },
    { filename: 'zoom_out' }
  ];

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) { }

  init(): void {
    this.SVG_ICONS.forEach(icon => {
      let name = icon.filename;
      if (icon.name) name = icon.name;
      this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(`assets/images/${icon.filename}.svg`));
    });
  }
}

interface Icon {
  filename: string;
  name?: string;
}
